import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  TableFooter,
  Paper,
} from "@mui/material";
import "./PhoneGridItems.scss";

export default function PhoneGridItems({
  articleDetails = [],
  invoiceTranslate,
  companiedDetails,
  transactiondetails,
}) {
  return (
    <div className="items-table">
      <TableContainer component={Paper} className="items-table__container">
        <Table className="items-table__table">
          {/* Header */}
          <TableHead>
            <TableRow className="items-table__header-row">
              <TableCell>{invoiceTranslate.barcode}</TableCell>
              <TableCell>{invoiceTranslate.itemDesc}</TableCell>
              <TableCell align="right">{invoiceTranslate.qty}</TableCell>
              <TableCell>{invoiceTranslate.artUnit}</TableCell>

              {companiedDetails &&
                companiedDetails.length > 0 &&
                (companiedDetails[0].VATDeclarant != 0 ? (
                  <>
                    <TableCell align="right">
                      {invoiceTranslate.priceNoVAT}
                    </TableCell>
                    <TableCell align="right">
                      {invoiceTranslate.amountNoVAT}
                    </TableCell>
                    <TableCell align="right">
                      {invoiceTranslate.vatRates}
                    </TableCell>
                    <TableCell align="right">
                      {invoiceTranslate.rabat}%
                    </TableCell>
                    <TableCell align="right">{invoiceTranslate.vat}</TableCell>
                    <TableCell align="right">
                      {invoiceTranslate.priceWithVAT}
                    </TableCell>
                    <TableCell align="right">
                      {invoiceTranslate.amountWithVAT}
                    </TableCell>
                  </>
                ) : (
                  <>
                    <TableCell align="right">
                      {invoiceTranslate.rabat}%
                    </TableCell>
                    <TableCell align="right">
                      {invoiceTranslate.price}
                    </TableCell>
                    <TableCell align="right">
                      {invoiceTranslate.amount}
                    </TableCell>
                  </>
                ))}
            </TableRow>
          </TableHead>

          {/* Body */}
          <TableBody>
            {articleDetails.length > 0 ? (
              articleDetails.map((item, index) => (
                <TableRow key={index} className="items-table__row">
                  <TableCell>{item.Barcode}</TableCell>
                  <TableCell className="font-medium">
                    {item.ArticleName}
                  </TableCell>
                  <TableCell align="center">
                    {transactiondetails &&
                    transactiondetails.length > 0 &&
                    transactiondetails[0].ActionType !== "IND"
                      ? item.QtyInput
                      : item.QtyOutput}
                  </TableCell>
                  <TableCell>{item.UnitName}</TableCell>

                  {companiedDetails &&
                    companiedDetails.length > 0 &&
                    (companiedDetails[0].VATDeclarant != 0 ? (
                      <>
                        <TableCell align="right">
                          {item.PriceWithoutVAT?.toFixed(2) ?? ""}
                        </TableCell>
                        <TableCell align="right">
                          {item.Amount?.toFixed(2) ?? ""}
                        </TableCell>
                        <TableCell align="right">
                          {item.VATRates?.toFixed(2) ?? ""}
                        </TableCell>
                        <TableCell align="right">
                          {item.DiscountPercent?.toFixed(2) ?? ""}
                        </TableCell>
                        <TableCell align="right">
                          {item.VAT?.toFixed(2) ?? ""}
                        </TableCell>
                        <TableCell align="right">
                          {item.PriceWithVAT?.toFixed(2) ?? ""}
                        </TableCell>
                        <TableCell align="right" className="items-table__total">
                          {item.Total?.toFixed(2) ?? ""}
                        </TableCell>
                      </>
                    ) : (
                      <>
                        <TableCell align="right">
                          {item.DiscountPercent?.toFixed(2) ?? ""}
                        </TableCell>
                        <TableCell align="right">
                          {item.PriceWithVAT?.toFixed(2) ?? ""}
                        </TableCell>
                        <TableCell align="right" className="items-table__total">
                          {item.Total?.toFixed(2) ?? ""}
                        </TableCell>
                      </>
                    ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={11}
                  align="center"
                  className="items-table__empty"
                >
                  No items available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
